import { HouseRaw } from '../types'
import DemoData from '../containers/Demo/resource/demo-house.json'

export const houseDate = [DemoData as unknown as HouseRaw] as HouseRaw[]

export const isDemoMode = () => {
	if (String(window.location).includes('houses/0')) {
		return true
	}
	return false
}
